<template>
  <validation-provider rules="is:accepted" name="terms">
    <b-form-checkbox
      v-model="innerValue"
      name="terms"
      value="accepted"
      unchecked-value="not_accepted"
    >
      By selecting this box, I agree that I have read, understand, and agree to be bound
      by LimeIQ's 
      <a
        @click.prevent.stop="
          () => $emitter.emit('toggle-termly-modal', 'terms-and-conditions')
        "
        class="text-dark text-underline"
        href
        >Terms of Service</a
      >,
      <a
        @click.prevent.stop="() => $emitter.emit('toggle-termly-modal', 'privacy-policy')"
        class="text-dark text-underline"
        href
        >Privacy Policy</a
      >,
      <a
        @click.prevent.stop="() => $emitter.emit('toggle-termly-modal', 'eula')"
        class="text-dark text-underline"
        href
        >EULA</a
      >, and
      <a
        @click.prevent.stop="
          () => $emitter.emit('toggle-termly-modal', 'acceptable-use-policy')
        "
        class="text-dark text-underline"
        href
        >Acceptable Use Policy</a
      >.
    </b-form-checkbox>
  </validation-provider>
</template>

<script>
import { defineComponent, computed } from "@vue/composition-api";

export default defineComponent({
  name: "TermlyCheckbox",
  emits: ["input"],
  props: {
    value: {
      type: String,
      default: "not_accepted",
    },
  },
  setup(props, { emit }) {
    const innerValue = computed({
      get: () => props.value,
      set: (newValue) => emit("input", newValue),
    });

    return {
      innerValue,
    };
  },
});
</script>

<style scoped>
>>> .custom-control {
  margin-bottom: 35px !important;
}
>>> .custom-control > .custom-control-label {
  padding-left: 23px;
  font-size: 80%;
}
>>> .custom-control > .custom-control-label::before {
  width: 15px;
  height: 15px;
}
>>> .custom-control > .custom-control-label::after {
  width: 4px;
  height: 8px;
  top: 2px;
  left: 6px !important;
}
</style>
